import FlashOnRoundedIcon from "@mui/icons-material/FlashOnRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import SpeedRounded from "@mui/icons-material/SpeedRounded";
import { EnergySavingsLeaf } from "@mui/icons-material";

export const steps = ["Servizio", "Profilo", "Contatti", "Privacy"];

export const kpiCards = [
  {
    title: "Risparmio Potenziale",
    value: "€ 300",
    helper: "All'anno",
    gradient: "linear-gradient(135deg, #14c26e, #10ac7d)",
    icon: <SavingsRoundedIcon fontSize="large" />,
  },
  {
    title: "Offerte Disponibili",
    value: "12",
    helper: "Fornitori attivi",
    gradient: "linear-gradient(135deg, #1c75ff, #4b9dff)",
    icon: <FlashOnRoundedIcon fontSize="large" />,
  },
  {
    title: "Tempo Cambio",
    value: "5 min",
    helper: "Procedura veloce",
    gradient: "linear-gradient(135deg, #ffb26b, #ff9f43)",
    icon: <SpeedRounded fontSize="large" />,
  },
  {
    title: "Eco-Friendly",
    value: "100%",
    helper: "Energia verde",
    gradient: "linear-gradient(135deg, #3ac6a8, #7ae9b4)",
    icon: <EnergySavingsLeaf fontSize="large" />,
  },
];

export const fornitori = [
  { id: "enel", name: "Enel", logo: "E", color: "#0066cc" },
  { id: "plenitude", name: "Plenitude", logo: "P", color: "#00a550" },
  { id: "iren", name: "Iren", logo: "I", color: "#d32f2f" },
  { id: "edison", name: "Edison", logo: "E", color: "#e53935" },
  { id: "acea", name: "Acea", logo: "A", color: "#1976d2" },
  { id: "sorgenia", name: "Sorgenia", logo: "S", color: "#00bcd4" },
  { id: "a2a", name: "A2A", logo: "A", color: "#1565c0" },
  { id: "altro", name: "ALTRO", logo: "+", color: "#757575" },
  {
    id: "prima",
    name: "PRIMA ATTIVAZIONE",
    logo: "⚡",
    color: "#4caf50",
  },
];
